import React, { useEffect, Suspense } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import "./assets/styles/responsive.css";
import "./assets/styles/main.css";
import { Layout } from "antd";
import PrivateRoute from "./pages/Auth/PrivateRoute";
import { ToastContainer } from "react-toastify";
import useFirebase from "./hooks/useFirebase";
import Loader from "./Loader";

const SignUp = React.lazy(() => import("./pages/Auth/SignUp"));
const SignIn = React.lazy(() => import("./pages/Auth/SignIn"));
const SignInOtp = React.lazy(() => import("./pages/Auth/SignIn otp"));
const HomeIndex = React.lazy(() => import("./pages/Home Page/Index"));
const ScanIndex = React.lazy(() => import("./pages/Home Page/ScanerIndex"));
const ReceiptIndex = React.lazy(() => import("./pages/Plan/Receipt"));
const RentalHistory = React.lazy(() => import("./pages/Rental/RentalHistory"));
const RentalDetails = React.lazy(() => import("./pages/Rental/RentalDetails"));
const NotificationIndex = React.lazy(() =>
  import("./pages/Notification/Index")
);
const SubscriptionIndex = React.lazy(() =>
  import("./pages/Subscription/Index")
);
const WalletIndex = React.lazy(() => import("./pages/Wallet/Index"));
const ReportIndex = React.lazy(() => import("./pages/Report an Issue/Index"));
const SupportIndex = React.lazy(() => import("./pages/Support/Index"));
const HowToIndex = React.lazy(() => import("./pages/How_to_use/Index"));
const ProfileIndex = React.lazy(() => import("./pages/My Profile/Index"));
const InviteIndex = React.lazy(() => import("./pages/Invite Friends/Index"));
const HelpIndex = React.lazy(() => import("./pages/Help/Index"));
const TermsConditionsIndex = React.lazy(() =>
  import("./pages/TermsConditions")
);
const PrivacypolicyIndex = React.lazy(() => import("./pages/Privacypolicy"));
const FaqIndex = React.lazy(() => import("./pages/Faq/Index"));
const VandorIndex = React.lazy(() => import("./pages/Home Page/VandorIndex"));
const TransactionErrorIndex = React.lazy(() => import("./pages/TransactionError/Index"));
const TransactionSuccessIndex = React.lazy(() => import("./pages/TransactionSuccess/Index"));
const PaymentCallbackIndex = React.lazy(() => import("./pages/PaymentCallback/Index"));

function App() {
  const { fcmToken } = useFirebase();
  useEffect(() => {
    const disableZoom = (e) => e.preventDefault();
    document.addEventListener("gesturestart", disableZoom);

    return () => {
      document.removeEventListener("gesturestart", disableZoom);
    };
  }, []);
  return (
    <Suspense fallback={<Loader />}>
      <ToastContainer closeOnClick />
      <BrowserRouter>
        <RouterChangeHandler />
        <Routes>
          <Route path="/sign-in" element={<SignIn />} />
          <Route path="/sign-in-otp" element={<SignInOtp />} />
          <Route path="/sign-up" element={<SignUp />} />
          <Route path="/" element={<HomeIndex />} />
          <Route path="/device-detail" element={<VandorIndex />} />
          <Route path="/scaner" element={<ScanIndex />} />
          <Route path="/receipt" element={<ReceiptIndex />} />
          <Route path="/rental-history" element={<RentalHistory />} />
          <Route path="/rental-details/:id" element={<RentalDetails />} />
          <Route path="/notification" element={<NotificationIndex />} />
          <Route path="/subscription" element={<SubscriptionIndex />} />
          <Route path="/wallet" element={<WalletIndex />} />
          <Route path="/report" element={<ReportIndex />} />
          <Route path="/support-chat" element={<SupportIndex />} />
          <Route path="/how-to-use" element={<HowToIndex />} />
          <Route path="/profile" element={<ProfileIndex />} />
          <Route path="/invite-friends" element={<InviteIndex />} />
          <Route path="/help" element={<HelpIndex />} />
          <Route path="/terms-conditions" element={<TermsConditionsIndex />} />
          <Route path="/privacy-policy" element={<PrivacypolicyIndex />} />
          <Route path="/faq" element={<FaqIndex />} />
          <Route path="/transaction-error" element={<TransactionErrorIndex />} />
          <Route path="/transaction-success" element={<TransactionSuccessIndex />} />
          <Route path="/payment-callback" element={<PaymentCallbackIndex />} />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Layout />
              </PrivateRoute>
            }
          ></Route>
        </Routes>
      </BrowserRouter>
    </Suspense>
  );
}

const RouterChangeHandler = React.memo(() => {
  const location = useLocation();

  useEffect(() => {
    const darkMode = localStorage.getItem("theme") === "dark";

    // 1. Switch stylesheet
    const existingLink = document.getElementById("theme-style");
    if (existingLink) existingLink.remove();

    const link = document.createElement("link");
    link.id = "theme-style";
    link.rel = "stylesheet";
    link.href = darkMode ? "/light.css" : "/dark.css";
    document.head.appendChild(link);

    // 2. Dynamically set theme-color meta tag
    const themeColor = darkMode ? "#262b2e" : "#ffffff";
    let metaThemeColor = document.querySelector('meta[name="theme-color"]');

    if (!metaThemeColor) {
      metaThemeColor = document.createElement("meta");
      metaThemeColor.name = "theme-color";
      document.head.appendChild(metaThemeColor);
    }

    metaThemeColor.setAttribute("content", themeColor);

    // 3. Store current theme
    localStorage.setItem("theme", darkMode ? "dark" : "light");

    return () => link.remove();
  }, [location]);

  return null;
});


export default App;
